if(!window.cablehouseCartLinkBound){window.cablehouseCartLinkBound=true;document.addEventListener('click',event=>{const link=event.target.closest('[data-cart-another]');if(!link)return;const chooser=document.querySelector('ch-product .chp-colours');const drawer=document.getElementById('cart-drawer');if(!chooser||typeof drawer?.close!=='function')return;event.preventDefault();drawer.close();setTimeout(()=>{chooser.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});chooser.querySelector('button')?.focus({preventScroll:true});},250);});}
if (!window.cablehouseBagBound) {
  window.cablehouseBagBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.ch-cart');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const drawer = document.getElementById('cart-drawer');
    if (typeof drawer?.open !== 'function') return;
    event.preventDefault();
    drawer.open();
  });
}
